import React from "react";
import "./WorkExperience.css";

export default function WorkExperience() {
  const items = [
    {
      id: 1,
      leftTitle: "Site Web et Application Mobiles",
      leftDate: "Adapté à votre budget.",
      dot: "red",
      rightTitle: "Contacter Nous",
      rightDesc:
        "Ecrivez nous sur nos numeros respectifs.",
    },
    {
      id: 2,
      leftTitle: "Gestion de Stock",
      leftDate: "Adapté à votre budget.",
      dot: "dark",
      rightTitle: "Envoi de Demo",
      rightDesc:
        "Nous vous enverrons un devis selon votre idée.",
    },
    {
      id: 3,
      leftTitle: "Paiements en ligne",
      leftDate: "Adapté à votre budget.",
      dot: "red",
      rightTitle: "Installation et Utilisation",
      rightDesc:
        "Nous vous ferons les implémentations et vous pouvez profiter de vos outils.",
    },
  ];

  return (
    <section className="weWrap-wex">
      <div className="weInner-wex">
        <h2 className="weTitle-wex">Comment ça marche ?</h2>

        <div className="weTable-wex" role="list">
          {items.map((it) => (
            <div key={it.id} className="weRow-wex" role="listitem">
              {/* LEFT */}
              <div className="weLeft-wex">
                <div className="weCompany-wex">{it.leftTitle}</div>
                <div className="weDate-wex">{it.leftDate}</div>
              </div>

              {/* CENTER LINE + DOT */}
              <div className="weMid-wex" aria-hidden="true">
                <span className="weLine-wex" />
                <span
                  className={`weDot-wex ${
                    it.dot === "red" ? "weDotRed-wex" : "weDotDark-wex"
                  }`}
                />
              </div>

              {/* RIGHT */}
              <div className="weRight-wex">
                <div className="weRole-wex">{it.rightTitle}</div>
                <div className="weDesc-wex">{it.rightDesc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
